module.exports = __webpack_public_path__ + "static/media/home-step-icon.64233246.svg";